import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

export default class SignNameModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.signName = Stream(app.session.user.signName());
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small';
  }

  title() {
    return app.translator.trans('dl-person.forum.changeSignNameModal.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group position-counter">
            <textarea className="FormControl" autocomplete="off" name="nickname" maxlength="50" rows="2" bidi={this.signName} disabled={this.loading} />
            {/* <input type="text" autocomplete="off" name="nickname" className="FormControl" bidi={this.signName} disabled={this.loading} /> */}
            <div id="counter">{this.signName()?this.signName().length:0}/50</div>
          </div>
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
              {app.translator.trans('dl-person.forum.changeSignNameModal.confirm')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onSuccess(text) {
    app.alerts.show({ type: 'success', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  }

  onWarn(text) {
    app.alerts.show({ type: 'warn', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  }

  onsubmit(e) {
    e.preventDefault();
    let alertText = app.translator.trans('dl-person.forum.changeSignNameModal.update_success');
    if (!this.signName()) {
      alertText = app.translator.trans('dl-person.forum.changeSignNameModal.warn_empty');
      this.onWarn(alertText);
      return;
    }

    if (this.signName() === app.session.user.signName()) {
      this.hide();
      return;
    }
    
   
    this.loading = true;

    app.session.user
      .save(
        { signName: this.signName() },
        {
          errorHandler: this.onerror.bind(this),
        }
      )
      .then(()=>{
        this.onSuccess(alertText);
        this.hide();
      })
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
